import React from "react";
import PropTypes from "prop-types";

function FacebookLink({isFacebookLinked}) {
  return (
    <div className="form-group row">
      <label htmlFor="facebook-link" className="col-6">
        <i className="fab fa-facebook-square pr-2" />
        Facebook
      </label>
      <div className="col-6 text-right">
        <input
          id="facebook-link"
          type="button"
          className={`btn ${ isFacebookLinked ? "btn-outline-secondary" : "btn-outline-primary" }`}
          value={isFacebookLinked ? "連携済み" : "連携する"}
          disabled
        />
      </div>
    </div>
  );
}

FacebookLink.propTypes = {
  isFacebookLinked: PropTypes.bool.isRequired
};

export default FacebookLink;
